import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../shared.service';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(private http: HttpClient) { }

  // PDF Methods
  getPdfInfo(pdfId: string): Observable<any> {
    return this.http.post<any>(
      `${environment.api_server}/api/newtecnoscopio/get/pdf`,
      { pdfId },
      { headers: SharedService.header }
    );
  }

  downloadPdf(pdfId: string): Observable<ArrayBuffer> {
    return this.http.post(
      `${environment.api_server}/api/newtecnoscopio/pfd/download`,
      { pdfId },
      {
        headers: SharedService.header,
        responseType: 'arraybuffer'
      }
    );
  }

  // Image Methods
  getImageInfo(fotoId: string): Observable<any> {
    return this.http.post<any>(
      `${environment.api_server}/api/newtecnoscopio/get/foto`,
      { fotoId },
      { headers: SharedService.header }
    );
  }

  downloadImage(fotoId: string): Observable<ArrayBuffer> {
    return this.http.post(
      `${environment.api_server}/api/newtecnoscopio/foto/download`,
      { fotoId },
      {
        headers: SharedService.header,
        responseType: 'arraybuffer'
      }
    );
  }
}